import React, { useEffect, useRef, useState } from 'react'
import {
  $goldenMayStatus,
  $isChangeStatusSuccess,
  changeStatus,
  changeStatusSubmit,
  goldenMayStatusMounted,
} from './model'
import { CButton, CCardBody, CCol, CRow } from '@coreui/react-pro'
import { useWinnersList } from './hooks'
import { InputRef, notification, Table } from 'antd'
import { FilterValue } from 'antd/es/table/interface'
import { ColumnsType } from 'antd/lib/table'
import { getColumnSearchProps } from '../../../../libs/tableFunctions'
import { Link } from 'react-router-dom'
import { path } from '../../../../libs'
import { Winner } from './types'
import { AddWinnersModal } from '../widgets/addWinnersModal/component'
import { useUnit } from 'effector-react'
import {
  $isAddWinnersSuccess,
  setIsAddWinnersSuccess,
} from '../widgets/addWinnersModal/model'
import { NotificationPlacement } from 'antd/es/notification/interface'
import { prizeTypes } from '../widgets/addWinnersModal/constants'

export const WinnersList: React.FC = () => {
  const goldenMayStatus = useUnit($goldenMayStatus)
  const isChangeStatusSuccess = useUnit($isChangeStatusSuccess)

  const { winners, onChangeWinnersList, totalCountOfWinners, loading } =
    useWinnersList()
  const isAddWinnersSuccess = useUnit($isAddWinnersSuccess)

  const [isAddWinnersModalOpen, setIsAddWinnersModalOpen] = useState(false)

  const [searchText, setSearchText] = useState<{
    [key: string]: string
  }>({})
  const [orderBy, setOrderBy] = useState('')
  const [orderDirection, setOrderDirection] = useState('-')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [filtersState, setFiltersState] = useState<
    Record<string, FilterValue | null>
  >({})

  const searchInput = useRef<InputRef>(null)

  const [api, contextHolder] = notification.useNotification()

  const openNotification = (placement: NotificationPlacement) => {
    api.success({
      message: `Success`,
      description: `Status changed to results`,
      placement,
    })
  }

  const handleTableChange = ({
    currentPage,
    currentPageSize,
    currentOrderBy,
    currentOrderDirection,
    filters,
  }: {
    currentPage?: number
    currentPageSize?: number
    currentOrderBy?: string
    currentOrderDirection?: string
    filters?: Record<string, FilterValue | null>
  }) => {
    if (currentPage) {
      setPage(currentPage)
    }
    if (currentPageSize) {
      setPageSize(currentPageSize)
    }
    if (currentOrderBy) {
      setOrderBy(currentOrderBy)
    }
    if (currentOrderDirection) {
      if (currentOrderDirection == 'descend') {
        setOrderDirection('-')
      } else {
        setOrderDirection('')
      }
    }
    if (filters) {
      setFiltersState(filters)
    }
  }

  useEffect(() => {
    onChangeWinnersList({
      limit: pageSize,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters: filtersState,
    })
  }, [pageSize, page, orderBy, orderDirection, filtersState, searchText])

  useEffect(() => {
    goldenMayStatusMounted()
  }, [])

  useEffect(() => {
    if (isAddWinnersSuccess) {
      onChangeWinnersList({
        limit: pageSize,
        page,
        orderBy,
        orderDirection,
        searchText,
        filters: filtersState,
      })
    }
  }, [isAddWinnersSuccess])

  useEffect(() => {
    if (isChangeStatusSuccess) {
      openNotification('topRight')
      goldenMayStatusMounted()
    }
  }, [isChangeStatusSuccess])

  const columns: ColumnsType<Winner> = [
    {
      title: 'ID',
      dataIndex: ['client', 'clientId'],
      ...getColumnSearchProps<Winner>(
        'client.clientId',
        setSearchText,
        searchText,
        searchInput,
      ),
      render: (id) => (
        <Link to={path.clients.details(id)} style={{ textDecoration: 'none' }}>
          {id}
        </Link>
      ),
    },
    {
      title: 'Name',
      dataIndex: ['client', 'fullName'],
      ...getColumnSearchProps<Winner>(
        'client.fullName',
        setSearchText,
        searchText,
        searchInput,
      ),
    },
    {
      title: 'Email',
      dataIndex: ['client', 'email'],
      ...getColumnSearchProps<Winner>(
        'client.email',
        setSearchText,
        searchText,
        searchInput,
      ),
    },
    {
      title: 'Ticket',
      dataIndex: 'ticketId',
      ...getColumnSearchProps<Winner>(
        'ticketId',
        setSearchText,
        searchText,
        searchInput,
      ),
    },
    {
      title: 'Prize',
      dataIndex: 'prizeType',
      filters: prizeTypes.map((item) => ({
        text: item.label,
        value: item.value,
      })),
    },
  ]

  return (
    <CCardBody>
      {contextHolder}
      {goldenMayStatus[0]?.status && (
        <CRow>
          <CCol className="mb-2">{`Status: ${goldenMayStatus[0]?.status}`}</CCol>
        </CRow>
      )}
      {goldenMayStatus[0]?.status === 'ended' && (
        <CRow className="justify-content-start">
          <CCol xs={4} className="d-flex gap-2 mb-2">
            <CButton
              color="primary"
              onClick={() => {
                setIsAddWinnersModalOpen(true)
                setIsAddWinnersSuccess(false)
              }}
            >
              Add winners
            </CButton>
            <CButton
              color="primary"
              onClick={() => {
                if (window.confirm('Are you sure')) {
                  changeStatusSubmit()
                }
              }}
            >
              Move to Results
            </CButton>
          </CCol>
        </CRow>
      )}
      <Table
        dataSource={winners}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        rowKey="winnersId"
        columns={columns}
        pagination={{
          showSizeChanger: true,
          total: totalCountOfWinners,
        }}
        onChange={(pagination, filters, sorter) =>
          handleTableChange({
            //@ts-ignore
            currentPage: pagination.current, //@ts-ignore
            currentPageSize: pagination.pageSize, //@ts-ignore
            currentOrderDirection: sorter.order, //@ts-ignore
            currentOrderBy: sorter.field,
            filters,
          })
        }
      />
      {isAddWinnersModalOpen && (
        <AddWinnersModal
          isVisible={isAddWinnersModalOpen}
          onClose={() => {
            setIsAddWinnersModalOpen(false)
          }}
        />
      )}
    </CCardBody>
  )
}
